"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var columns = [{
  title: 'Name',
  dataIndex: 'name',
  key: 'name',
  render: function render(text) {
    return /*#__PURE__*/_react.default.createElement("a", null, text);
  }
}, {
  title: 'Age',
  dataIndex: 'age',
  key: 'age'
}, {
  title: 'Address',
  dataIndex: 'address',
  key: 'address'
}, {
  title: 'Tags',
  key: 'tags',
  dataIndex: 'tags',
  render: function render(tags) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tags.map(function (tag) {
      var color = tag.length > 5 ? 'geekblue' : 'green';
      if (tag === 'loser') {
        color = 'volcano';
      }
      return /*#__PURE__*/_react.default.createElement(_antd.Tag, {
        color: color,
        key: tag
      }, tag.toUpperCase());
    }));
  }
}, {
  title: 'Action',
  key: 'action',
  render: function render(_, record) {
    return /*#__PURE__*/_react.default.createElement(_antd.Space, {
      size: "middle"
    }, /*#__PURE__*/_react.default.createElement("a", null, "Invite ", record.name), " ", /*#__PURE__*/_react.default.createElement("a", null, "Delete"));
  }
}];
var data = [{
  key: '1',
  name: 'John Brown',
  age: 32,
  address: 'New York No. 1 Lake Park',
  tags: ['nice', 'developer']
}, {
  key: '2',
  name: 'Jim Green',
  age: 42,
  address: 'London No. 1 Lake Park',
  tags: ['loser']
}, {
  key: '3',
  name: 'Joe Black',
  age: 32,
  address: 'Sidney No. 1 Lake Park',
  tags: ['cool', 'teacher']
}];
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: data,
    pagination: false
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimaryActive', 'colorBgContainer'],
  key: 'table'
};
var _default = exports.default = componentDemo;